/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep } from 'lodash';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';

const __vue_script__ = {
    name: 'Checkboxes',

    components: { Checkbox },

    extends: BaseControl,

    props: {
        value: {
            type: [Array, Object],
            default: () => null
        },

        options: {
            type: Array,
            required: true
        },

        inline: {
            type: Boolean,
            default: false,
        },

        showToggler: {
            type: Boolean,
            default: false
        },

        itemised: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            innerValue: cloneDeep(this.options)
        };
    },

    computed: {
        /** @returns {boolean} */
        allSelected() {
            return this.innerValue.every(o => o.value);
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (!Array.isArray(value)) {
                    this.innerValue = cloneDeep(this.options);
                    this.innerValue.forEach(o => {
                        o.name = o.value;
                        o.value = value[o.name];
                    });
                } else {
                    this.innerValue = cloneDeep(this.options)
                        .map(d => {
                            if (d.hidden) { return d; }
                            return { ...d, value: value.includes(d.name) };
                        });
                }
            }
        }
    },

    methods: {
        /**
         * Input changed handler
         *
         * @param {boolean} value the checkbox value
         * @param {{name: string, value: boolean}} option the changed option
         */
        onInput(value, option) {
            const opt = this.innerValue.find(o => o.name === option.name);
            const index = this.innerValue.findIndex(o => o.name === option.name);
            opt.value = value;
            this.$set(this.innerValue, index, opt);
            this.emit();
        },

        /**
         * Toggles all options to the given value
         *
         * @param {boolean} value the value to toggle
         */
        toggleAll(value) {
            this.innerValue.forEach((item, index) => {
                if (!item.disabled) {
                    item.value = value;
                    this.$set(this.innerValue, index, item);
                }
            });
            this.emit();
        },

        /**
         * Emits the value of the control
         */
        emit() {
            if (Array.isArray(this.value)) {
                this.$emit('input', this.innerValue.filter(o => o.value).map(o => o.name));
            } else {
                const obj = {};
                this.innerValue.forEach(o => {
                    obj[o.name] = o.value;
                });
                this.$emit('input', obj);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      staticClass: "checkboxgroup",
      class: { "checkboxgroup-inline": _vm.inline },
      attrs: {
        label: _vm.label,
        tip: _vm.tip,
        name: _vm.name,
        hint: _vm.hint,
        errors: _vm.errors,
        uid: _vm.uid,
        "hint-after-label": true,
        warning: _vm.warning,
        dependant: _vm.dependant,
      },
    },
    [
      _c(
        "div",
        { staticClass: "options-list" },
        [
          _vm.showToggler
            ? [
                !_vm.allSelected
                  ? _c(
                      "a",
                      {
                        staticClass: "toggler",
                        on: {
                          click: function ($event) {
                            return _vm.toggleAll(true)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.forms.select_all")))]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "toggler",
                        on: {
                          click: function ($event) {
                            return _vm.toggleAll(false)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.forms.deselect_all")))]
                    ),
              ]
            : _vm._e(),
          _vm._l(_vm.innerValue, function (opt) {
            return _c(
              "checkbox",
              _vm._b(
                {
                  key: opt.name,
                  class: {
                    "has-error":
                      _vm.errors.length || (opt.errors && opt.errors.length),
                    "has-warning": _vm.warning,
                    hidden: opt.hidden,
                  },
                  attrs: {
                    itemised: _vm.itemised,
                    disabled: _vm.disabled || opt.disabled,
                  },
                  on: {
                    input: function (value) {
                      return _vm.onInput(value, opt)
                    },
                  },
                },
                "checkbox",
                opt,
                false
              )
            )
          }),
        ],
        2
      ),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/Checkboxes.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__